(function () {
"use strict";
function $197cd56b15c33885$export$d0cc010c49859b05() {
    if (window.innerWidth >= 1200) window.location.hash = "";
}
window.addEventListener("resize", $197cd56b15c33885$export$d0cc010c49859b05);

})();
//# sourceMappingURL=index.460be580.js.map
